var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/NavigationModelRepo/NavigationModelRepoFolder.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { ApiDomain } from '../domain';
import { createPredicate } from '../createPredicate';
import { Urn } from '../Urn';
import { NavigationBimFile } from './NavigationBimFile';
export var NavigationModelRepoFolder;

(function (_NavigationModelRepoFolder) {
  var domain = ApiDomain.domain('NavigationModelRepoFolder', {
    name: "domain",
    sid: "fw3xyc"
  });
  var gStationModelRepositoryFolderType = 'GStationModelRepositoryFolder';
  var bim360ModelRepositoryFolderType = 'Bim360ModelRepositoryFolder';
  var ModelRepoFolder = _NavigationModelRepoFolder.ModelRepoFolder = t.type({
    projectUrn: Urn,
    name: t.string,
    urn: Urn,
    type: t.union([t.literal(gStationModelRepositoryFolderType), t.literal(bim360ModelRepositoryFolderType)]),
    parentFolderUrn: t.union([t["null"], Urn]),
    hasChildren: t["boolean"]
  });
  var Data = _NavigationModelRepoFolder.Data = t.type({
    list: t.array(t.union([ModelRepoFolder, NavigationBimFile.io])),
    total: t.number
  });
  var isGStationModelRepositoryFolder = _NavigationModelRepoFolder.isGStationModelRepositoryFolder = createPredicate(gStationModelRepositoryFolderType);
  var isBim360ModelRepositoryFolder = _NavigationModelRepoFolder.isBim360ModelRepositoryFolder = createPredicate(bim360ModelRepositoryFolderType);
  var fetchRootFolders = _NavigationModelRepoFolder.fetchRootFolders = ApiCallService.create({
    name: 'fetchRootFolders',
    parentDomain: domain,
    result: Data,
    getKey: ['projectUrn']
  });
  var fetchFolderContent = _NavigationModelRepoFolder.fetchFolderContent = ApiCallService.create({
    name: 'fetchFolderContent',
    parentDomain: domain,
    result: Data,
    getKey: ['folderUrn', 'projectUrn']
  });
})(NavigationModelRepoFolder || (NavigationModelRepoFolder = {}));